<template>
  <!-- 退款详情详细信息 -->
  <div class="re_det">
    <div
      class="order_id font12 font_weight500 colo087 line_height_20 text_left"
    >
      <div>
        <span class="order_item">订单编号：</span>{{ getAfterSaleInfo.orderSn }}
      </div>
      <div
        v-clipboard:copy="getAfterSaleInfo.orderSn"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        class="font_weight400 colo087 copy_id"
      >
        复制
      </div>
    </div>
    <div
      class="order_id font12 font_weight500 colo087 line_height_20 text_left border_bottom1px"
    >
      <div>
        <span class="order_item">退款编号：</span>{{ getAfterSaleInfo.id }}
      </div>
      <div
        v-clipboard:copy="getAfterSaleInfo.id"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        class="font_weight400 colo087 copy_id"
      >
        复制
      </div>
    </div>
    <div
      class="order_id1 font12 font_weight500 colo087 line_height_20 text_left ma_top"
    >
      <span class="order_item">退款原因：</span>{{ getAfterSaleInfo.reason }}
    </div>
    <div
      class="order_id1 font12 font_weight500 colo087 line_height_20 text_left ma_top"
    >
      <span class="order_item">退款金额：</span
      >{{ getAfterSaleInfo.returnPrice | currency(false) }}
    </div>
    <div
      class="order_id1 font12 font_weight500 colo087 line_height_20 text_left ma_top"
    >
      <span class="order_item">退款运费：</span
      >{{ getAfterSaleInfo.returnFreight | currency(false) }}
    </div>
    <div
      class="order_id1 font12 font_weight500 colo087 line_height_20 text_left ma_top"
    >
      <span class="order_item">退款数量：</span
      >{{ getAfterSaleInfo.afterSaleNum }}
    </div>
    <div
      v-if="
        getAfterSaleInfo.periods &&
          getAfterSaleInfo.periods !== null &&
          getAfterSaleInfo.periods.length
      "
      class="order_id1 font12 font_weight500 colo087 line_height_20 text_left ma_top item_flex"
    >
      <div class="order_item">退款周期：</div>
      <div>
        <div v-for="(item, index) in getAfterSaleInfo.periods" :key="index">
          第{{ item.seqNo }}期（{{ item.planDeliveredAt }}）
        </div>
      </div>
    </div>
    <div
      class="order_id1 font12 font_weight500 colo087 line_height_20 text_left ma_top"
    >
      <span class="order_item">申请时间：</span
      >{{
        getAfterSaleInfo.gmtCreate | dateFormatterJava("YYYY-MM-DD HH:mm:ss")
      }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getAfterSaleInfo() {
      return this.$store.getters.getAfterSaleInfo;
    }
  },
  methods: {
    onCopy() {
      this.$toast("运单号已复制到剪贴板！");
    },
    onError() {
      this.$toast("复制失败，请重试！");
    }
  }
};
</script>

<style lang="less" scoped>
.re_det {
  background: #fff;
  margin-top: 12px;
  padding: 12px;
  .order_id {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-bottom: 12px;
    .copy_id {
      padding: 0 8px;
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.38);
    }
  }
  .order_item {
    margin-right: 14px;
  }
  .ma_top {
    padding-top: 12px;
  }
}
.item_flex {
  display: flex;
}
</style>
